<!--<div class="content">
  <h1 class="main-title">
    <span id="lblTitle">تسجيل الدخول</span>
  </h1>
  <div id="UAEPassLoginCont" class="fO UAEPassLogin">
    <input type="button" class="sso-button" />
    <div style="line-height: 20px">
      <h5 style="margin-top: 10px">
        <b>هوية رقمية واحدة موثوقة للجميع المواطنين والمقيمين والزوار </b>
      </h5>
    </div>
  </div>
</div>-->
<div class="container">
  <div class="row">
    <div class="col-md-3">
      <app-login-dashboard></app-login-dashboard>
    </div>
    <div class="col-md-9">
      <app-uaepass-login-error *ngIf="error"></app-uaepass-login-error>
      <div *ngIf="!error" id="userProfileContainer" class="container card">
        <h3 [ngClass]="{ 'main-title': isEnglish, 'main-title-ar': isArabic }">
          {{ 'UserProfile.UAEPassProfileLinkingTitle' | translate }}
        </h3>
        <div id="_DivSSOIndividual" class="ssoUserLogin es">
          <span id="individualLoginTitle" class="ssoPageQues">{{
            'UserProfile.LoginIndividual' | translate
          }}</span>

          <input *ngIf="!UserTypesModel?.IndividualUser"
            type="button"
            name="btnIndividualManualLink"
            value="{{ 'UserProfile.LinkIndividual' | translate }}"
            (click)="navigateToRegistration(1)"
            data-toggle="modal"
            data-target="#manualLinkPopup"
            id="btnIndividualManualLink"
            class="btn-manual-link"
          />
          <input *ngIf="UserTypesModel?.IndividualUser"
          type="submit"
          name="BtnLogin"
          [value]="isEnglish?(UserTypesModel?.IndividualUser?.NameEn):(UserTypesModel?.IndividualUser?.NameAr)"
          id="BtnLogin"
          class="btn-company-selection"
          (click)="login(UserTypesModel?.IndividualUser)"
        />
          <div id="DivSSOIndividualAgents" class="ssoUserLogin">
            <input
              *ngFor="let user of UserTypesModel?.OtherIndividualUsers"
              type="submit"
              name="BtnLogin"
              [value]="isEnglish?user.NameEn:user.NameAr"
              id="BtnLogin"
              class="btn-company-selection"
              (click)="login(user)"
            />
          </div>
        </div>
        <div id="DivSSOAgents" class="ssoUserLogin es">
          <span class="ssoPageQues">{{
            'UserProfile.LoginCompany' | translate
          }}</span>
          <div id="DivCompanyAgentList" class="ssoUserLogin">
            <input
              type="submit"
              name="btnAgentManualLink"
              value="{{ 'UserProfile.LinkCompany' | translate }}"
              (click)="navigateToRegistration(2)"
              data-toggle="modal"
              data-target="#manualLinkPopup"
              id="btnAgentManualLink"
              class="btn-manual-link"
            />
            <input
              *ngFor="let user of UserTypesModel?.CompanyUsers"
              type="submit"
              name="BtnLogin"
              [value]="isEnglish?user.NameEn:user.NameAr"
              id="BtnLogin"
              class="btn-company-selection"
              (click)="login(user)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
